"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixRedHearts = void 0;
function fixRedHearts(tex) {
    return tex.replace(new RegExp(`\\\\red\\s*♥`, "g"), "\\red{♥}");
}
exports.fixRedHearts = fixRedHearts;
